import '@barev/ui/styles.css';
import './app.css';
import './redesign.css';
import { ApiProvider, loadTextOverrides, getInitData, initTelegram, ToastProvider } from '@barev/web';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';

initTelegram();
// названия и описания услуг, изменённые в админке
void loadTextOverrides();
const initData = getInitData();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApiProvider headers={() => ({ authorization: `tma ${initData}` })}>
      <ToastProvider>
        <App hasInitData={!!initData} />
      </ToastProvider>
    </ApiProvider>
  </StrictMode>,
);
